import ApiService from "@/service/apiService";
import Api from "@/config/api";

export default {
  state: {
    currentUserSearchTemplate: [],
  },
  getters: {
    getCurrentUserSearchTemplate(state) {
      return state.currentUserSearchTemplate;
    },
  },
  mutations: {
    setCurrentUserSearchTemplate(state, data) {
      state.currentUserSearchTemplate = data;
    },
    setNewTemplate(state, data) {
      const isNewTemplateDefault = data.is_default;
      if (isNewTemplateDefault) {
        const defaultSearchTemplate = state.currentUserSearchTemplate.find(
          (template) => template.is_default
        );
        if (defaultSearchTemplate) {
          defaultSearchTemplate.is_default = false;
        }
      }
      state.currentUserSearchTemplate.unshift(data);
    },
    unsetTemplate(state, data) {
      const tempArray = state.currentUserSearchTemplate.find(
        (template) => template.id === data.id
      );
      const index = state.currentUserSearchTemplate.indexOf(tempArray);
      if (index > -1) {
        state.currentUserSearchTemplate.splice(index, 1);
      }
    },
    mutateSearchTemplateAfterEdit(state, template) {
      const newTemplates = state.currentUserSearchTemplate.map(
        (searchTemplate) => {
          if (template.id == searchTemplate.id) {
            searchTemplate = template;
            return searchTemplate;
          } else {
            return searchTemplate;
          }
        }
      );
      state.currentUserSearchTemplate = [];
      // console.log(newTemplates);
      state.currentUserSearchTemplate = newTemplates;
    },
    mutateSearchTemplateAfterChange(state, template) {
      const newTemplates = state.currentUserSearchTemplate.map(
        (searchTemplate) => {
          if (template.id == searchTemplate.id) {
            searchTemplate.is_default = template.is_default;
            return searchTemplate;
          } else {
            if (template.is_default) {
              searchTemplate.is_default = false;
            }
            return searchTemplate;
          }
        }
      );
      console.log(newTemplates);
      state.currentUserSearchTemplate = [];
      state.currentUserSearchTemplate = newTemplates;
    },
    clearTemplate(state) {
      /* eslint-disable */
      state.currentUserSearchTemplate = [];
    },
  },
  actions: {
    async loadCurrentUserSearchTemplate({ commit }) {
      try {
        const userSearchTemplate = await ApiService.get(
          Api.endpoints.CURRENTUSER_SEARCH_TEMPLATE
        );
        commit("setCurrentUserSearchTemplate", userSearchTemplate.data.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
